import { getDaysSincePublished } from './date_utils';
import { Listing } from './rql';

export function isNewListing(listing: Listing) {
  const daysSincePublished = getDaysSincePublished(listing.publishedAt?.seconds);
  return daysSincePublished <= 3;
}
